import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Login from './pages/login';
import Learning from './pages/learning';
import MainPage from './pages/main';
import UsersService from "./services/users-service";

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookReader, faHome, faNotesMedical, faCog, faExclamationTriangle, faCommentAlt,
    faPhoneSquare,
    faTasks,
    faBell,
    faMapMarkerAlt,
    faStickyNote,
    faUsers,
    faUser,
    faPhone,
    faBars,
	faSignOutAlt,
	faArrowLeft,
	faTrashAlt,
	faDownload,
	faPencilAlt,
} from '@fortawesome/free-solid-svg-icons'

import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';

library.add(
	faBookReader, faHome, faCog, faNotesMedical, faExclamationTriangle,
	faCommentAlt, faPhoneSquare,faTasks, faBell, faMapMarkerAlt, faStickyNote,
	faUsers, faUser, faPhone, faBars, faSignOutAlt, faArrowLeft, faTrashAlt,
	faDownload, faPencilAlt
);


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
              user: null,
              page: "Settings",
             // fullLoginDetails: {dude: "Hello po"},
        }
        this.pageChange = this.pageChange.bind(this);
		this.setLoggedInUser = this.setLoggedInUser.bind(this);
    this.handleLogout = this.handleLogout.bind(this);

		const storedCredenials = UsersService.sharedInstance.getStoredCredentials();

		const isLoggedIn = localStorage.getItem("loggedIn");
		const usernameLoggedIn = storedCredenials.username;
		const licenseLoggedIn = storedCredenials.license;
		const tokenLoggedIn = storedCredenials.token;

		var currentUser = null;
		// isLoggedIn = false;

		if (isLoggedIn === 'true'){
			currentUser = {username: usernameLoggedIn, license: licenseLoggedIn, token: tokenLoggedIn};
			this.state = {
				page: <MainPage currentPage={this.state.page} pageChange={this.pageChange} user={this.state.user} fullLoginDetails={this.state.fullLoginDetails}/>,
				user:currentUser
			};
		}
		else {
			this.state = {
				page: <Login pageChange={this.pageChange} setLoggedInUser={this.setLoggedInUser}/>,
				user: null,//Object with user id's and stuff
			};
		}
	}

  	componentDidMount(){
  		// this.setLoggedOutUser();
  	}

    render() {
        return (
            <div className="App">
                {this.state.page}
            </div>
        );
    }

    //Temp routing
    pageChange(page, fullLoginDetails, redirectState) {
  		this.setState({
          	page: page,
            fullLoginDetails: fullLoginDetails == null ? this.state.fullLoginDetails : fullLoginDetails
        });
  		switch(page) {
  			case "Login":
  			   this.setState({page: <Login pageChange={this.pageChange} setLoggedInUser={this.setLoggedInUser}/>});
  			break;
        case "Logout":
            this.handleLogout();
        break;
  			default:
         this.setState({page: <MainPage currentPage={page}
                                        pageChange={this.pageChange} user={this.state.user}
                                        fullLoginDetails={this.state.fullLoginDetails}
                                        redirectState={redirectState}/>});

  			break;
  		}
    }

    //This shoiuld be a Redux function. -TERE
    setLoggedInUser(user) {
      	this.setState({
        	user: user,
      	});
    }

  	setLoggedOutUser(){
  		localStorage.setItem("loggedIn", false);
  		this.setState({user: null, fullLoginDetails: null});
  	}

    handleLogout(){
        UsersService.sharedInstance.logout();
        window.location.reload();
    }

}

export default App;
